import React, { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import OfflineBanner from './components/OfflineBanner';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import AnalyticsPage from './pages/AnalyticsPage';
import GamificationPage from './pages/GamificationPage';
import NavBar from './components/NavBar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Hook to detect offline status
function useOfflineStatus() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  return offline;
}


function Root() {
  const { user, loading } = useAuth();
  const offline = useOfflineStatus();
  if (loading) return null; // Optionally add a splash screen
  return user ? (
    <Router>
      <div className="app-shell">
        {offline && <OfflineBanner />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/gamification" element={<GamificationPage />} />
        </Routes>
        <NavBar />
      </div>
    </Router>
  ) : <LoginPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <Root />
    </AuthProvider>
  );
}
